/* eslint-disable no-implicit-coercion */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";

import BreadCrumb from "../../components/breadCrumb";
import Loader from "../../components/PageLoader";
import ReactHookFormDropdown from "../../components/forms/react-hook-dropdown";
import FormInput from "../../components/forms/form-Input";
import NumericInput from "../../components/forms/react-hook-numeric-input";

import {
  NOTIFICATION_TYPES,
  EVENT_CATEGORIES,
  ESCALATION_LEVELS,
  NOTIFICATION_CHANNELS,
  NOTIFICATION_TRIGGER,
  OLA_NOTIFICATION_TYPES,
  SLA_ASSIGNMENT_GROUPS,
  OLA_ASSIGNMENT_GROUPS,
} from "./constants";
import {
  useLookupCustomers,
  useLookupRegions,
} from "../../services/lookups-mutations";

import {
  useGetNotificationDetail,
  usePutNotificationRule,
} from "../../services/notifications";

import { Paths } from "../../routes/paths";
import { ACTIVITY_TYPES } from "pages/customers/constants";
import { Button, Flex } from "@chakra-ui/react";
import ReactHookFormMultiSelect from "components/forms/react-hook-multiselect";

/* ---------------- OLA ACTIVITY TYPES ---------------- */
const OLA_NEW_TICKET_ACTIVITY_TYPES = [
  { id: "Customer Service", text: "Customer Service" },
  { id: "ETISALAT Third Party", text: "ETISALAT Third Party" },
  { id: "Facilities Request", text: "Facilities Request" },
  { id: "TGM Remote Support", text: "TGM Remote Support" },
  { id: "Unusual Event", text: "Unusual Event" },
  { id: "Customer Complaints", text: "Customer Complaints" },
];

const OLA_OTHER_ACTIVITY_TYPES = [
  ...OLA_NEW_TICKET_ACTIVITY_TYPES,
  { id: "Voice Of Staff", text: "Voice Of Staff" },
  { id: "Incident - Standard", text: "Incident - Standard" },
  { id: "Incident - Emergency", text: "Incident - Emergency" },
  { id: "Panic Alert Incident", text: "Panic Alert Incident" },
  { id: "Marketing", text: "Marketing" },
  { id: "Missed And Delayed Services", text: "Missed And Delayed Services" },
  { id: "TGSI Helpdesk", text: "TGSI Helpdesk" },
];

export default function EditNotification() {
  const navigate = useNavigate();
  const { notificationId } = useParams();

  /* ---------------- LOOKUPS ---------------- */
  const {
    mutate: getCustomers,
    data: customersList,
    isPending: loadingCustomers,
  } = useLookupCustomers();

  const { mutate: getRegions, data: regionsList } = useLookupRegions();

  const {
    mutate: getNotificationDetail,
    data: detailRes,
    isPending: loadingDetail,
  } = useGetNotificationDetail();

  const {
    mutate: editNotification,
    isPending: saving,
    isSuccess,
  } = usePutNotificationRule();

  /* ---------------- FORM ---------------- */
  const {
    handleSubmit,
    control,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      eventCategory: null,
      description: "",
      notificationType: null,
      threshold: "",
      whenSent: null,
      escalationLevel: [],
      assignmentGroup: null,
      activities: [],
      customers: [],
      regions: [],
      notificationChannels: [],
      isActive: true,
    },
  });

  const watchNotificationType = watch("notificationType");
  const selectedEventCategory = watch("eventCategory");
  const isOLA = selectedEventCategory === "OLA";

  const prevEventCategoryRef = useRef(null);

  useEffect(() => {
    if (prevEventCategoryRef.current === null) {
      prevEventCategoryRef.current = selectedEventCategory;
      return;
    }

    if (prevEventCategoryRef.current !== selectedEventCategory) {
      const currentValues = watch();

      reset({
        ...currentValues,
        notificationType: null,
        assignmentGroup: null,
        activities: [],
      });
    }

    prevEventCategoryRef.current = selectedEventCategory;
  }, [selectedEventCategory]);

  /* ---------------- NORMALIZATION ---------------- */
  const normalizedCustomers = useMemo(
    () =>
      [{ customerId: "All", name: "All" }, ...(customersList?.data || [])].map(
        (c) => ({
          customerId: String(c.customerId ?? ""),
          name: String(c.name ?? ""),
        }),
      ),
    [customersList],
  );

  const normalizedRegions = useMemo(
    () =>
      [{ id: "All", name: "All" }, ...(regionsList?.data || [])].map((r) => ({
        id: String(r.id ?? r.name ?? ""),
        name: String(r.name ?? ""),
      })),
    [regionsList],
  );

  let normalizedActivities = [{ id: "All", text: "All" }];

  normalizedActivities = useMemo(
    () => [
      ...normalizedActivities,
      ...ACTIVITY_TYPES.map((a) => ({
        id: String(a.value ?? ""),
        text: String(a.label ?? ""),
      })),
    ],
    [],
  );

  /* ---------------- FETCH DATA ---------------- */
  useEffect(() => {
    getCustomers();
    // getAssignmentGroup();
    getRegions("UAE");
    if (notificationId) getNotificationDetail(notificationId);
  }, [notificationId]);

  /* ---------------- RESET FORM ---------------- */
  useEffect(() => {
    const res = detailRes?.data;
    if (!res) return;

    const isOla = res.eventCategory === "OLA";
    const notificationTypeOption = res.notificationType;
    // isOla
    //   ? OLA_NOTIFICATION_TYPES.find((n) => n === res.notificationType)
    //   : NOTIFICATION_TYPES.find((n) => n === res.notificationType);

    const whenSentOption = isOla ? res.whenSent : null;

    // Determine activity source for OLA
    const activitySource = !isOla
      ? ACTIVITY_TYPES
      : notificationTypeOption === "New Ticket Created"
        ? OLA_NEW_TICKET_ACTIVITY_TYPES
        : OLA_OTHER_ACTIVITY_TYPES;

    const normalizedActivitySource = [
      { id: "All", text: "All" },
      ...activitySource.map((a) => ({
        id: String(a.id),
        text: String(a.text),
      })),
    ];
    reset({
      eventCategory: res.eventCategory,
      // EVENT_CATEGORIES.find((e) => e === res.eventCategory) || null,
      description: res.description ?? "",
      notificationType: notificationTypeOption || null,
      threshold: res.threshold ?? "",
      whenSent: whenSentOption || null,
      escalationLevel:
        ESCALATION_LEVELS.filter((e) => res.escalationLevel?.includes(e.id)) ||
        [],
      assignmentGroup: res.assignmentGroup ? res.assignmentGroup : null,
      activities:
        normalizedActivitySource.filter((a) =>
          res.activities?.includes(a.id),
        ) || [],
      customers:
        normalizedCustomers.filter((c) =>
          res.customers?.includes(c.customerId),
        ) || [],
      regions:
        normalizedRegions.filter((r) => res.regions?.includes(r.name)) || [],
      notificationChannels:
        res.notificationChannels
          ?.map((c) => NOTIFICATION_CHANNELS.find((n) => n.id === c))
          .filter(Boolean) || [],
      isActive: Boolean(res.isActive),
    });
  }, [
    detailRes,
    reset,
    normalizedCustomers,
    normalizedRegions,
    normalizedActivities,
  ]);

  /* ---------------- ALL SELECTION ---------------- */
  const handleAllSelection = (values, key = "id") => {
    const hasAll = values.some((v) => v[key] === "All");
    if (!hasAll) return values;
    return values.length > 1 ? values.filter((v) => v[key] !== "All") : values;
  };

  /* ---------------- DYNAMIC ACTIVITY OPTIONS ---------------- */
  // const getActivityOptions = (selectedValues = []) => {
  //   if (!isOLA) return normalizedActivities;

  //   const isNewTicket = watchNotificationType === "NewTicketCreated";

  //   return isNewTicket
  //     ? OLA_NEW_TICKET_ACTIVITY_TYPES
  //     : OLA_OTHER_ACTIVITY_TYPES;
  // };

  /* ---------------- SAVE ---------------- */
  const onSave = (data) => {
    const thresholdType = ["AboutToBreach", "Breach"].includes(
      data.notificationType,
    )
      ? "PercentageElapsed"
      : "MinutesAfterBreach";

    editNotification({
      id: notificationId,
      payload: {
        eventCategory: data.eventCategory,
        description: data.description,
        threshold: Number(data.threshold),
        thresholdType,
        notificationType: data.notificationType,
        escalationLevel: data.escalationLevel.map((e) => e.id),
        assignmentGroup: data.assignmentGroup,
        regions: data.regions.map((r) => r.name),
        activities: data.activities.map((a) => a.id),
        customers: data.customers.map((c) => c.customerId),
        isActive: data.isActive,
        whenSent: isOLA ? data.whenSent : null,
        notificationChannels: data.notificationChannels.map((c) => c.id),
      },
    });
  };

  useEffect(() => {
    if (isSuccess) navigate(Paths.notification);
  }, [isSuccess]);

  /* ---------------- FORM VALIDATION ---------------- */
  const FORM_VALIDATION = {
    description: { required: "Please Enter Description" },
    eventCategory: { required: "Please Select a Value" },
    notificationType: { required: "Please Select Notification Type" },
    threshold: { required: "Please Enter Threshold" },
    whenSent: {
      validate: (v) => !isOLA || !!v || "When Sent is required",
    },
    escalationLevel: {
      validate: (v) => (v && v.length > 0) || "Please Select Escalation Level",
    },
    assignmentGroup: { required: "Please Select Assignment Group" },
    activities: {
      validate: (v) => (v && v.length > 0) || "Please Select Activity",
    },
    customers: {
      validate: (v) => (v && v.length > 0) || "Please Select Customer",
    },
    regions: {
      validate: (v) => (v && v.length > 0) || "Please Select Region(s)",
    },
    notificationChannels: {
      validate: (v) => v?.length > 0 || "Please Select Notification Channels",
    },
  };

  /* ================= RENDER ================= */
  return (
    <>
      {loadingCustomers || loadingDetail || saving ? <Loader /> : null}

      <div style={{ maxWidth: "100%", margin: "0 auto", padding: "20px" }}>
        <BreadCrumb
          links={[
            { text: "Notification Rules", link: Paths.notification },
            { text: "Edit Notification Rule", isCurrentPage: true },
          ]}
        />

        <div className="bg-white p-6 rounded shadow">
          <h2 className="text-lg font-semibold mb-4">Edit Notification</h2>

          <form onSubmit={handleSubmit(onSave)} className="space-y-4">
            {/* ACTIVE */}
            <Controller
              control={control}
              name="isActive"
              render={({ field }) => (
                <label className="flex items-center space-x-2 mb-2">
                  <input
                    type="checkbox"
                    checked={field.value}
                    onChange={(e) => field.onChange(e.target.checked)}
                  />
                  <span>Active</span>
                </label>
              )}
            />

            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {/* EVENT CATEGORY */}
              <ReactHookFormDropdown
                isRequired
                placeholder="Select a Value"
                control={control}
                errors={errors}
                label="Type"
                name="eventCategory"
                id="id"
                text="text"
                data={EVENT_CATEGORIES}
                rules={FORM_VALIDATION.eventCategory}
              />

              {/* DESCRIPTION */}
              <FormInput
                control={control}
                errors={errors}
                isRequired
                label="Description"
                name="description"
                rules={FORM_VALIDATION.description}
              />

              {/* NOTIFICATION TYPE */}
              <ReactHookFormDropdown
                control={control}
                errors={errors}
                isRequired
                label="Notification Type"
                name="notificationType"
                id="id"
                text="text"
                data={isOLA ? OLA_NOTIFICATION_TYPES : NOTIFICATION_TYPES}
                placeholder="Select a Value"
                rules={FORM_VALIDATION.notificationType}
              />

              {/* THRESHOLD */}
              <NumericInput
                control={control}
                errors={errors}
                isRequired
                label={`Threshold (${watchNotificationType === "BreachEscalation" ? "min" : "%"})`}
                name="threshold"
                rules={FORM_VALIDATION.threshold}
                inputProps={
                  watchNotificationType !== "BreachEscalation"
                    ? {
                        min: 1,
                        max: 100,
                      }
                    : {
                        max: 500,
                      }
                }
              />

              {/* WHEN SENT */}
              {isOLA ? (
                <ReactHookFormDropdown
                  control={control}
                  isRequired
                  placeholder="Select a Value"
                  errors={errors}
                  label="When Sent"
                  name="whenSent"
                  // id="id"
                  // text="text"
                  data={NOTIFICATION_TRIGGER}
                  rules={FORM_VALIDATION.whenSent}
                />
              ) : null}

              {/* ASSIGNMENT GROUP */}
              <ReactHookFormDropdown
                control={control}
                errors={errors}
                isRequired
                filterable
                label="Assignment Group"
                name="assignmentGroup"
                id="value"
                text="label"
                data={(isOLA
                  ? OLA_ASSIGNMENT_GROUPS
                  : SLA_ASSIGNMENT_GROUPS
                ).map((item) => ({
                  value: item.name,
                  label: item.name,
                  name: item.name,
                }))}
                placeholder="Select a Value"
                rules={FORM_VALIDATION.assignmentGroup}
              />

              {/* ESCALATION LEVEL */}
              <ReactHookFormMultiSelect
                label="Escalation Level"
                name="escalationLevel"
                control={control}
                errors={errors}
                isRequired
                filterable
                data={ESCALATION_LEVELS}
                id="id"
                text="text"
                rules={FORM_VALIDATION.escalationLevel}
                placeholder="Select a Value"
              />

              {/* ACTIVITIES */}
              <ReactHookFormMultiSelect
                label="Activity Types"
                name="activities"
                control={control}
                errors={errors}
                isRequired
                filterable
                data={normalizedActivities}
                id="id"
                text="text"
                rules={FORM_VALIDATION.activities}
                placeholder="Select a Value"
                onChange={(value) => handleAllSelection(value, "id")}
              />

              {/* CUSTOMERS */}
              <ReactHookFormMultiSelect
                label="Customers"
                name="customers"
                control={control}
                errors={errors}
                isRequired
                filterable
                data={normalizedCustomers}
                id="customerId"
                text="name"
                rules={FORM_VALIDATION.customers}
                placeholder="Select a Value"
                onChange={(value) => handleAllSelection(value, "customerId")}
              />

              {/* REGIONS */}
              <ReactHookFormMultiSelect
                label="Regions"
                name="regions"
                control={control}
                errors={errors}
                isRequired
                filterable
                data={normalizedRegions}
                id="id"
                text="name"
                rules={FORM_VALIDATION.regions}
                placeholder="Select a Value"
                onChange={(value) => handleAllSelection(value, "id")}
              />

              {/* NOTIFICATION CHANNELS */}
              <ReactHookFormMultiSelect
                label="Notification Channels"
                name="notificationChannels"
                filterable
                control={control}
                errors={errors}
                data={NOTIFICATION_CHANNELS}
                id="id"
                text="text"
                placeholder="Select a Value"
              />
            </div>

            {/* ACTION BUTTONS */}
            <Flex justify="flex-end" mt="30px" gap="10px">
              <Button
                variant="outline"
                onClick={() => navigate(Paths.notification)}
              >
                Cancel
              </Button>
              <Button type="submit">Update Notification Rule</Button>
            </Flex>
          </form>
        </div>
      </div>
    </>
  );
}
